import "@/App.css";
import { useLenis } from "@/hooks/useLenis";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import QuickQuote from "@/components/QuickQuote";
import ServicesBento from "@/components/ServicesBento";
import AboutStory from "@/components/AboutStory";
import CoverageArea from "@/components/CoverageArea";
import Fleet from "@/components/Fleet";
import Testimonials from "@/components/Testimonials";
import OrderApp from "@/components/OrderApp";
import ClosedRibbon from "@/components/ClosedRibbon";
import Footer from "@/components/Footer";

function App() {
  useLenis();

  return (
    <div className="relative min-h-screen overflow-x-clip bg-[#0C1F17] text-[#F6F1E3]">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <QuickQuote />
        <ServicesBento />
        <AboutStory />
        <CoverageArea />
        <Fleet />
        <Testimonials />
        <OrderApp />
      </main>
      <Footer />
      <ClosedRibbon />
    </div>
  );
}

export default App;
